<script>
    import CommonRules from "@/mixins/CommonRules";
    import UserAuth from "@/mixins/UserAuth";
    import Languages from "@/mixins/dictionaries/Languages";
    export default {
        name: "DocumentSettingsCommon",
        mixins: [
            CommonRules,
            UserAuth,
            Languages,
        ],
        components: {
            VTextFieldColorPicker: () => import('@/components/commonComponents/VTextFieldColorPicker'),
            VTextFieldDatePicker: () => import('@/components/commonComponents/VTextFieldDatePicker'),
        },
        props: {
            document: {
                type: Object,
                required: true
            },
            isDisabled: Boolean,
        },
        data() {
            return {
                pageSize: {
                    width: 210,
                    height: 297
                }
            };
        },
        computed: {
            permissions() {
                return this.document?.permissions;
            },
            maxLeft() {
                const diff = this.pageSize.width - this.document.padding_right;
                return diff > 0 ? diff : 0;
            },
            maxRight() {
                const diff = this.pageSize.width - this.document.padding_left;
                return diff > 0 ? diff : 0;
            },
            maxTop() {
                const diff = this.pageSize.height - this.document.padding_bottom;
                return diff > 0 ? diff : 0;
            },
            maxBottom() {
                const diff = this.pageSize.height - this.document.padding_top;
                return diff > 0 ? diff : 0;
            },
        },
        methods: {
            isDisabledField(field) {
                return this.isDisabled || (!this.isNew && this.permissions !== undefined && !this.permissions?.isEditableField[field]);
            },
        }
    };
</script>

<template>
    <div>
        <v-container fluid v-if="true">
            <v-row class="pa-0">
                <v-col class="pa-0" :cols="12" :sm="12">
                    <v-autocomplete
                        v-model="document.language"
                        :disabled="isDisabledField('language')"
                        :items="dictionaries.languages"
                        :rules="[rules.required]"
                        label="Язык"
                        class="required"
                        item-text="name"
                        item-value="id"
                    ></v-autocomplete>
                </v-col>
            </v-row>
            <v-row class="pa-0">
                <v-col :cols="12" :sm="12" class="pa-0">
                    <v-text-field
                        label="Наименование"
                        v-model="document.name"
                        :rules="[rules.required]"
                        :disabled="isDisabledField('name')"
                        class="required"
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row class="pa-0">
                <v-col :cols="12" :sm="12" class="pa-0">
                    <v-text-field-date-picker
                        v-model="document.date_start"
                        :rules="[rules.required]"
                        :disabled="isDisabledField('date_start')"
                        label="Дата выхода"
                        class="required"
                    ></v-text-field-date-picker>
                </v-col>
            </v-row>
            <v-row>
                <v-col :cols="12" :sm="12">
                    <div class="hr-sect">Отступы</div>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="pl-0 py-0">
                    <v-text-field
                        v-model="document.padding_left"
                        dense
                        type="number"
                        suffix="mm"
                        :rules="[rules.numberOfRange(0, maxLeft)]"
                        :disabled="isDisabledField('padding_left')"
                        label="…слева"
                        class="required"
                    ></v-text-field>
                </v-col>
                <v-col class="py-0">
                    <v-text-field
                        v-model="document.padding_right"
                        dense
                        type="number"
                        suffix="mm"
                        :rules="[rules.numberOfRange(0, maxRight)]"
                        :disabled="isDisabledField('padding_right')"
                        label="…справа"
                        class="required"
                    ></v-text-field>
                </v-col>
                <v-col class="py-0">
                    <v-text-field
                        v-model="document.padding_top"
                        dense
                        type="number"
                        suffix="mm"
                        :rules="[rules.numberOfRange(0, maxTop)]"
                        :disabled="isDisabledField('padding_top')"
                        label="…сверху"
                        class="required"
                    ></v-text-field>
                </v-col>
                <v-col class="pr-0 py-0">
                    <v-text-field
                        v-model="document.padding_bottom"
                        dense
                        type="number"
                        suffix="mm"
                        :rules="[rules.numberOfRange(0, maxBottom)]"
                        :disabled="isDisabledField('padding_bottom')"
                        label="…снизу"
                        class="required"
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col :cols="12" :sm="12">
                    <div class="hr-sect">Цвет текста</div>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="pl-0 py-0">
                    <v-text-field-color-picker
                        v-model="document.secondary_color"
                        :disabled="isDisabledField('secondary_color')"
                        :rules="[rules.color]"
                        label="Заголовки"
                        class="required"
                    ></v-text-field-color-picker>
                </v-col>
                <v-col class="pr-0 py-0">
                    <v-text-field-color-picker
                        v-model="document.primary_color"
                        :disabled="isDisabledField('primary_color')"
                        :rules="[rules.color]"
                        label="Основной текст"
                        class="required"
                    ></v-text-field-color-picker>
                </v-col>
            </v-row>
        </v-container>
        <template v-else>
            <v-list dense class="d-flex flex-wrap">
                <v-list-item class="col-md-12">
                    <v-list-item-action>
                        <v-text-field-date-picker
                            v-model="document.date_start"
                            :rules="[rules.required]"
                            :disabled="isDisabledField('date_start')"
                            label="Дата выхода"
                            class="required"
                        ></v-text-field-date-picker>
                    </v-list-item-action>
                </v-list-item>
                <v-list-item class="col-md-6">
                </v-list-item>
            </v-list>
            <v-list dense class="d-flex flex-wrap">
                <v-list-item class="col-md-12">
                    <div class="hr-sect pa-0">Отступы</div>
                </v-list-item>
                <v-list-item class="col-md-6">
                    <v-list-item-title>Отступ слева</v-list-item-title>
                    <v-list-item-action>
                        <v-text-field
                            v-model="document.padding_left"
                            dense
                            type="number"
                            suffix="mm"
                            :rules="[rules.numberOfRange(0, maxLeft)]"
                            :disabled="isDisabledField('padding_left')"
                            label="…слева"
                            class="required"
                        ></v-text-field>
                    </v-list-item-action>
                </v-list-item>
                <v-list-item class="col-md-6">
                    <v-list-item-title>Отступ справа</v-list-item-title>
                    <v-list-item-action>
                        <v-text-field
                            v-model="document.padding_right"
                            dense
                            type="number"
                            suffix="mm"
                            :rules="[rules.numberOfRange(0, maxRight)]"
                            :disabled="isDisabledField('padding_right')"
                            label="…справа"
                            class="required"
                        ></v-text-field>
                    </v-list-item-action>
                </v-list-item>
                <v-list-item class="col-md-6">
                    <v-list-item-title>Отступ сверху</v-list-item-title>
                    <v-list-item-action>
                        <v-text-field
                            v-model="document.padding_top"
                            dense
                            type="number"
                            suffix="mm"
                            :rules="[rules.numberOfRange(0, maxTop)]"
                            :disabled="isDisabledField('padding_top')"
                            label="…сверху"
                            class="required"
                        ></v-text-field>
                    </v-list-item-action>
                </v-list-item>
                <v-list-item class="col-md-6">
                    <v-list-item-title>Отступ снизу</v-list-item-title>
                    <v-list-item-action>
                        <v-text-field
                            v-model="document.padding_bottom"
                            dense
                            type="number"
                            suffix="mm"
                            :rules="[rules.numberOfRange(0, maxBottom)]"
                            :disabled="isDisabledField('padding_bottom')"
                            label="…снизу"
                            class="required"
                        ></v-text-field>
                    </v-list-item-action>
                </v-list-item>
            </v-list>
            <v-list dense class="d-flex flex-wrap">
                <v-list-item class="col-md-12">
                    <div class="hr-sect pa-0">Цвет текста</div>
                </v-list-item>
                <v-list-item class="col-md-6">
                    <v-list-item-title>Заголовки</v-list-item-title>
                    <v-list-item-action>
                        <v-text-field-color-picker
                            v-model="document.secondary_color"
                            :disabled="isDisabledField('secondary_color')"
                            :rules="[rules.color]"
                            label="Заголовки"
                            class="required"
                        ></v-text-field-color-picker>
                    </v-list-item-action>
                </v-list-item>
                <v-list-item class="col-md-6">
                    <v-list-item-title>Основной текст</v-list-item-title>
                    <v-list-item-action>
                        <v-text-field-color-picker
                            v-model="document.primary_color"
                            :disabled="isDisabledField('primary_color')"
                            :rules="[rules.color]"
                            label="Основной текст"
                            class="required"
                        ></v-text-field-color-picker>
                    </v-list-item-action>
                </v-list-item>
            </v-list>
        </template>
    </div>
</template>

<style lang="scss" scoped>
    @media (min-width: 960px) {
        .v-list.d-flex {
            justify-content: space-between;
            gap: 0 20px;
        }
        .col-md-6 {
            flex: 0 1 45%;
            padding: 6px 0;   
        }
        .col-md-12 {
            padding: 0;
            .v-list-item__title {
                color: rgba(0, 0, 0, 0.38);
            }
        }
    }
    
    .v-application--is-ltr {
        .col-md-6 .v-list-item__action:last-of-type:not(:only-child) {
            margin-left: 0;
        }
        .v-list-item__action:first-child, .v-list-item__icon:first-child {
            margin-right: 0;
        }
    }
    .v-list-item__action {
        margin: 0;
    }
    
    .v-list { 
        .v-list-item {
            display: flex;
            justify-content: flex-start;
            align-content: flex-start;
            align-items: flex-start;
            .v-list-item__action ::v-deep .v-input.error--text .v-text-field__details { 
                top: 5px;
                position: relative;
                .v-messages {
                    display: flex;
                }
            }
        }
    }

    .hr-sect {
        display: flex;
        flex-basis: 100%;
        align-items: center;
        color: rgba(0, 0, 0, 0.35);
        margin: 8px 0;
        font-size: 12px;

        &:before, &:after {
            content: "";
            flex-grow: 1;
            background: rgba(0, 0, 0, 0.15);
            height: 1px;
            font-size: 0;
            line-height: 0;
            margin: 0 8px;
        }
    }
</style>